module.exports = __webpack_public_path__ + "assets/images/edge1000-ca1784a7faa09926abe105964a4aca2b.jpg";